// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import chat from "@src/views/apps/chat/store/reducer";
import todo from "@src/views/apps/todo/store/reducer";
import users from "@src/views/apps/user/store/reducer";
import email from "@src/views/apps/email/store/reducer";
import invoice from "@src/views/apps/invoice/store/reducer";
import calendar from "@src/views/apps/calendar/store/reducer";
import ecommerce from "@src/views/apps/ecommerce/store/reducer";
import dataTables from "@src/views/tables/data-tables/store/reducer";
import certificates from "@src/views/pages/certificates/store/reducer";
import exams from "@src/views/pages/exams/store/reducer";
import category from "@src/views/pages/theme/store/reducer";
import worksheet from "@src/views/pages/worksheets/store/reducer";
import promo from "@src/views/pages/Promocode/store/reducer";
import plan from "@src/views/pages/Plans/store/reducer";
import questionBank from "@src/views/pages/question-bank/store/reducer";
import userReducer from "@src/views/pages/users/store/reducers";
import examUserReducer from "@src/views/pages/exam-users/store/reducers";
import eventsReducer from "@src/views/pages/events/store/reducer"
import teamsReducer from "@src/views/pages/teams/store/reducer";
import groupsReducer from "@src/views/pages/groups/store/reducer";
import lessonsReducer from "@src/views/pages/lessons/store/reducer";
import mmosUsersReducer from "@src/views/pages/mmosUsers/store/reducer";
import academicReducer from "@src/views/pages/directory/academicLevel/store/reducer";
import subjectReducer from "@src/views/pages/directory/subjects/store/reducer";
import strandReducer from "@src/views/pages/directory/strand/store/reducer";
import topicReducer from "@src/views/pages/directory/topic/store/reducer";
import heuristicReducer from "@src/views/pages/directory/heuristic/store/reducer";
import strategyReducer from "@src/views/pages/directory/strategy/store/reducer";
import bonusActivityReducer from "../../views/pages/bonus/store/reducer";
import claimReducer from "../../views/pages/claimBonus/store/reducer"
import samplesReducer from "../../views/pages/directory/sample/store/reducer"
import subscriptionReducer from "../../views/pages/free-trial/store/reducer";
import tagsReducer from "../../views/pages/tags/store/reducer";
const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  certificates,
  exams,
  questionBank,
  category,
  worksheet,
  promo,
  plan,
  userReducer,
  examUserReducer,
  eventsReducer,
  teamsReducer,
  groupsReducer,
  lessonsReducer,
  mmosUsersReducer,
  academicReducer,
  subjectReducer,
  strandReducer,
  topicReducer,
  heuristicReducer,
  strategyReducer,
  bonusActivityReducer,
  claimReducer,
  samplesReducer,
  subscriptionReducer,
  tagsReducer
});

export default rootReducer;
